import { COMPLIANCE_POLICY_STATES } from '../constants';
import { Badge } from 'framework/ui/mui-builder';
import { useFieldHelper, FieldProps } from 'framework/ui/field';

type PolicyStageBadgeFieldProps = {
  label?: string;
  source?: string;
  value?: Nullable<boolean>;
} & FieldProps<boolean>;

const PolicyStageBadgeField = ({ source, value }: PolicyStageBadgeFieldProps) => {
  const { getValue } = useFieldHelper<boolean>({ source, value });
  const isPolicyAccepted = getValue();

  return (
    <Badge color={isPolicyAccepted ? 'success' : 'error'}>
      {isPolicyAccepted ? COMPLIANCE_POLICY_STATES.COMPLIANT : COMPLIANCE_POLICY_STATES.NOT_COMPLIANT}
    </Badge>
  );
};

export default PolicyStageBadgeField;
